import React from 'react';
import { AccordionItem } from './ui/Accordion';
import { bonos } from './data';
export function BonosAccordion() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto bg-zinc-900/20 rounded-3xl border border-zinc-800/50 my-12" data-id="element-12">
      <div className="text-center bg-amber-400/10 border border-amber-400/30 p-5 rounded-xl mb-8" data-id="element-13">
        <p className="text-2xl md:text-3xl font-display font-bold text-amber-400 animate-pulse" data-id="element-14">
          ¡ESTOS BONOS SON GRATIS POR EL DÍA DE HOY!
        </p>
      </div>

      <div className="space-y-1" data-id="element-15">
        {bonos.map((bono, index) => <AccordionItem key={index} title={bono.title} data-id="element-16">
            <ul className="space-y-4" data-id="element-17">
              {bono.content.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-18">
                  <span className="text-amber-400 mt-1" data-id="element-19">→</span>
                  <span className="leading-relaxed text-sm sm:text-base" data-id="element-20">
                    {item}
                  </span>
                </li>)}
            </ul>
          </AccordionItem>)}
      </div>
    </section>;
}